import { clsx, type ClassValue } from 'clsx';

/** Joins class names. Components never merge conflicting utilities – variants own their styles. */
export const cn = (...inputs: ClassValue[]) => clsx(inputs);
